import { Button, Checkbox } from "~/components/ui";
import type { ColumnDef, Row } from "@tanstack/react-table";
import { PenIcon, TrashIcon } from "lucide-react";
import { DeleteConfirm } from "~/components/common/confirm";

export const defaultTableColumns: { [key: string]: ColumnDef<any> } = {
  select: {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllRowsSelected()}
        onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
      />
    ),

    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        disabled={!row.getCanSelect()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
};

export type TableActionEventType = "edit" | "delete";

export function getActionColDefs(
  resource: string,
  callback: (type: TableActionEventType, row: Row<any>) => void,
  permittedEdit: boolean,
  permittedDelete: boolean,
): ColumnDef<any>[] {
  if (!permittedEdit && !permittedDelete) return [] as ColumnDef<any>[];
  return [
    {
      id: "actions",
      header: "",
      cell: ({ row }: any) => (
        <div className="flex gap-2 mx-2">
          {permittedEdit && (
            <Button
              variant="ghost"
              size="icon"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                callback("edit", row);
              }}
            >
              <PenIcon className="h-4 w-4" />
            </Button>
          )}
          {permittedDelete && (
            <DeleteConfirm
              trigger={
                <Button variant="ghost" size="icon" type="button">
                  <TrashIcon className="h-4 w-4" color="red" />
                </Button>
              }
              title={resource + ".deleteConfirmTitle"}
              description={resource + ".deleteConfirmDescription"}
              onConfirm={() => callback("delete", row)}
            />
          )}
        </div>
      ),
      enableSorting: false,
      enableHiding: false,
    },
  ];
}
